export default __webpack_public_path__ + "assets/images/a890df1eb1996d44b1f9670393ed7387.png";